import { api } from 'API';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/DisabilityCertificate';

export interface IDisabledVeteran {
  firstName: string;
  lastName: string;
  engFirstName: string;
  engLastName: string;
  israeliId: string;
  caseNumber: string;
  disabilityValidTo: string;
  queueExemptionRemark: string;
  queueExemptionRemarkEnglish: string;
  serviceDogRemark: string;
  serviceDogRemarkEnglish: string;
}

export const getDisabledVeteran = async () => {
  const disabledVeteran = await api.get<IDisabledVeteran>(
    addImposterToUrl(baseUrl, true)
  );
  if (disabledVeteran.data) {
    return disabledVeteran.data;
  }
};
